/* eslint-disable @typescript-eslint/member-ordering */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DetailModalFlightResultComponent } from './detail-modal-flight-result/detail-modal-flight-result.component';

@Component({
  selector: 'usb-flight-result',
  templateUrl: './flight-result.component.html',
  styleUrls: ['./flight-result.component.scss']
})
export class FlightResultComponent implements OnInit {
  @Input() payload: any;
  @Input() _form: any;
  @Input() result: any;
  @Input() arrayResults: any;
  @Input() index: number;
  @Input() form: FormGroup;
  @Input() currencies: any[];
  @Input() origin: string;
  @Input() mapView: Boolean = false;
  @Input() itineraryCurrency = '';
  @Input() clientsSettingAppBooking: any;
  @Input() currencyAgency: any;
  @Input() qtyProductValid: number;
  @Input() paymentAgencyActive: any;
  @Output() openModalDetailEmitter = new EventEmitter<any>();
  @Output() coordinatesClicked = new EventEmitter<any>();
  @Output() modalClosedemitter = new EventEmitter<any>();
  @Output() qtyProductValidDecrementEmmit = new EventEmitter<any>();

  modalRef: BsModalRef;
  fontSizeAdjustments = { 6: -12, 9: -15, 12: -19 };
  stylePathPrice: any;
  formLocal: any;
  originalResult: any;
  constructor(
              public userService: UserService,
              private modalService: BsModalService
              ) { }

  ngOnInit(): void {
        this.formLocal = JSON.parse(localStorage.getItem('form'));
        this.stylePathPrice = JSON.parse(this.clientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_body);
        this.originalResult = this.deepCopy(this.result);
  }

      // Método para deep copy
  private deepCopy(obj: any): any {
    if (obj === null || typeof obj !== 'object') {
return obj;
}
    if (obj instanceof Date) {
return new Date(obj.getTime());
}
    if (obj instanceof Array) {
return obj.map(item => this.deepCopy(item));
}

    const copiedObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        copiedObj[key] = this.deepCopy(obj[key]);
      }
    }
    return copiedObj;
  }

  openModalDetail(flightData: any): void {
    this.openModalDetailEmitter.emit(flightData);
    // const initialState = {
    //   flightData,
    //   payload: this.payload,
    //   arrayResults: this.arrayResults
    // };

    // this.modalRef = this.modalService.show(
    //   DetailModalFlightResultComponent,
    //   {
    //     initialState,
    //     class: 'modal-lg modal-dialog-centered',
    //     backdrop: 'static',
    //     keyboard: false
    //   }
    // );

    // this.modalRef.content.productAdded.subscribe(() => {
    //   this.qtyProductValidDecrementEmmit.emit();
    //   this.modalClosedemitter.emit('success');
    // });
  }

  getCancellationPolicy(canllationPolicy: any): void {

  }

  getDateInfo(action: string): string {

    let date = '';
    let segmentLength = 0;

    switch(action) {

      // dates
      case 'departureInitial':
        date = this.result?.itinerary?.[0].options[0]?.segments[0]?.departure?.dateTime;
        break;
      case 'arrivalDestination':
        segmentLength = this.result?.itinerary?.[0].options[0]?.segments.length;
        date = this.result?.itinerary?.[0].options[0]?.segments[segmentLength - 1]?.arrival?.dateTime;
        break;

      // city
      case 'departureCity':
        date = this.result?.itinerary?.[0].options[0]?.segments[0]?.departure?.city;
        break;
      case 'arrivalDestinationCity':
        segmentLength = this.result?.itinerary?.[0].options[0]?.segments.length;
        date = this.result?.itinerary?.[0].options[0]?.segments[segmentLength - 1]?.arrival?.city;
        break;

      // iata
      case 'departureAirportIata':
        date = this.result?.itinerary?.[0].options[0]?.segments[0]?.departure?.airport;
        break;
      case 'arrivalDestinationAirportIata':
        segmentLength = this.result?.itinerary?.[0].options[0]?.segments.length;
        date = this.result?.itinerary?.[0].options[0]?.segments[segmentLength - 1]?.arrival?.airport;
        break;

      // cantidad segmento
      case 'segmentQty':
        segmentLength = Number(this.result?.itinerary?.[0].options[0]?.segments.length);
        let dateString = '';

        if(segmentLength === 2) {
          dateString = `1 escala`;
        } else if(segmentLength > 2) {
          dateString = `${segmentLength - 1} escalas`;
        } else {
          dateString = 'Directo';
        }

        date = dateString;
        break;

        // duración de vuelo
      case 'durationFlight':
        date = this.result?.itinerary?.[0].duration;
        break;

        // clase
      case 'class':
        date = this.result?.itinerary?.[0].options[0]?.segments[0]?.cabin?.class;

    }

    return date;
  }


}
